import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  LoginAuthUserInputFields,
  LoginContent
} from './models/login-credentials.interface';

@Component({
  selector: 'idp-login-authentication-screen',
  templateUrl: './login-authentication-screen.component.html',
  styleUrls: ['./login-authentication-screen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginAuthenticationScreenComponent implements OnInit, OnChanges {
  @Output() formSubmitEvent: EventEmitter<LoginAuthUserInputFields> =
    new EventEmitter<LoginAuthUserInputFields>();

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() footerLinkClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() logOut = new EventEmitter();
  @Input() toggleModalCallback!: () => void;
  @Input() recognitionPage!: boolean;
  @Input() checkOutWarmState = false;
  @Input()
  content: LoginContent | null | undefined = {} as LoginContent;

  form!: UntypedFormGroup | undefined;
  @Output() isLastNameEnabled = new EventEmitter<boolean>();
  @Output() formAlertDisplay: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit() {
    this.form = this.content?.formGroup;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.checkSkyMilesNumber(changes)) {
      this.content.formGroup.patchValue({
        userId: {
          value: changes.content.currentValue.skyMilesNumber,
          id: 'userId'
        }
      });
      this.content.formGroup.patchValue({
        keepMeLoggedIn: { value: true }
      });
      this.content.formGroup.controls['userId'].disable();
    }
  }

  private checkSkyMilesNumber(changes: SimpleChanges) {
    return (
      changes &&
      changes.content &&
      changes.content.currentValue &&
      changes.content.currentValue.skyMilesNumber
    );
  }

  public get showErrorMessageuserId() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.content?.formGroup?.get('userId')
    );
    return (
      control &&
      this.content?.loginFormAttributes?.userIdControlTouched &&
      control?.invalid
    );
  }

  public get showErrorMessagePassword() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.content?.formGroup?.get('password')
    );
    return (
      control &&
      this.content?.loginFormAttributes.passwordControlTouched &&
      control.invalid
    );
  }

  public get showErrorMessageLastName() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.content?.formGroup?.get('lastName')
    );
    return (
      control &&
      this.content?.loginFormAttributes.lastNameControlTouched &&
      control.invalid
    );
  }

  firstInvalidFieldFocusEvent() {
    this.focusInvalidField.emit();
  }

  submit() {
    const userInputFields: LoginAuthUserInputFields = {
      userName: this.content?.formGroup.get('userId')?.value?.value,
      password: this.content?.formGroup.get('password')?.value?.value,
      lastName: this.content?.formGroup.get('lastName')?.value?.value,
      persistentLogin: this.content?.formGroup.get('keepMeLoggedIn')?.value
        ?.value
        ? 'Y'
        : 'N'
    };
    this.formSubmitEvent.emit(userInputFields);
  }

  onFocussedOut(fieldName: string) {
    this.fieldFocusOut.emit(fieldName);
  }

  onChange() {
    this.isLastNameEnabled.emit(
      this.content?.loginFormAttributes?.isLastNameRequired
    );

    this.inputChange.emit();
  }

  onClosePop() {
    this.formAlertDisplay.emit();
  }

  onFooterLinkClick(viewName: string) {
    this.footerLinkClick.emit(viewName);
  }
}
